/* unplugin-vue-components disabled */import { render } from "./Remote.vue?vue&type=template&id=4385e104"
import script from "./Remote.vue?vue&type=script&lang=js"
export * from "./Remote.vue?vue&type=script&lang=js"

import "./Remote.vue?vue&type=style&index=0&id=4385e104&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__